import intentHolder, {INTENT_FOR_EXISTING_CUSTOMER, INTENT_FOR_NEW_CUSTOMER} from "@/models/intent-holder";
import { deepGet } from "@/utils/helper-functions"

let btClientInstance = undefined;
export function updateBTClientInstance(instance) {
    btClientInstance = instance;
}

export const DEFAULT_PI_AMOUNT = 100
export const THREEDS_DEFAULT_PI_AMOUNT = 100
export const IDEAL_DEFAULT_PI_AMOUNT = 100
export const SOFORT_DEFAULT_PI_AMOUNT = 100
export const BANCONTACT_DEFAULT_PI_AMOUNT = 100
export const GIROPAY_DEFAULT_PI_AMOUNT = 1 // 1 cent
export const DOTPAY_DEFAULT_PI_AMOUNT = 100
export const NETBANKING_DEFAULT_PI_AMOUNT = 100
export const UPI_DEFAULT_PI_AMOUNT = 100

function getAddress(addr) {
  return {
    firstName: addr.first_name,
    lastName: addr.last_name,
    addressLine1: addr.line1,
    addressLine2: addr.line2,
    addressLine3: addr.line3,
    city: addr.city,
    state: addr.state,
    stateCode: addr.state_code,
    countryCode: addr.country,
    zip: addr.zip,
  }
}

function getCardBillingAddress(pm) {
  return {
    firstName: pm.first_name,
    lastName: pm.last_name,
    addressLine1: pm.billing_addr1,
    addressLine2: pm.billing_addr2,
    city: pm.billing_city,
    state: pm.billing_state,
    stateCode: pm.billing_state_code,
    countryCode: pm.billing_country,
    zip: pm.billing_zip,
  }
}

function getCustomerInfo(store) {
  const customer = store.state.customer.data || {};
  return {
    firstName: customer.first_name,
    lastName: customer.last_name,
    phone: customer.phone,
    email: customer.email,
  }
}

function getCustomerBillingAddress(store) {
  const addr = (store.state.customer && store.state.customer.billing_address) || {}
  return getAddress(addr)
}

function getShippingAddress(store) {
  const addr = store.getters.selected_shipping_address;
  if(addr) return getAddress(addr)
}

export function createPaymentIntent(store, payment_method = {}, options = {}) {
  const getters = store.getters;
  const state = store.state;
  let pm =getters.pm_list.filter((gw) => gw.enabled3ds==true && gw.type=="card")[0];
  const params = {
    amount: undefined,
    currencyCode: getters.currency_code || store.state.customer.data.preferred_currency_code,
    intent: getters.payment_intent,
    paymentMethodType: payment_method.type
  }

  if(options.amount != undefined) {
    params.amount = options.amount
  } else if (getters.current_amount_due) {
    params.amount = getters.current_amount_due
  } else if((pm && pm.token_amount3ds) != undefined) {
    params.amount = pm && pm.token_amount3ds
  }

  if(options.paymentMethodType) {
    params.paymentMethodType = options.paymentMethodType
  }

  if (params["amount"] == undefined ) {
    params["amount"] = THREEDS_DEFAULT_PI_AMOUNT
  }

  return Promise.resolve().then(() => {
    if(state.auth.authenticated) {
      params["customerId"] = getters.customer_handle
      params["paymentSourceId"] = payment_method.reference_id
      params["gatewayId"] = payment_method.gateway_account_id
      return intentHolder.set(INTENT_FOR_EXISTING_CUSTOMER, params);
      }
    else {
      params["gatewayId"] = payment_method.gateway_account_id
      return intentHolder.set(INTENT_FOR_NEW_CUSTOMER, params);
    }
  }).then(({payment_intent}) => {
    store.dispatch("set_payment_intent", payment_intent)
    return payment_intent;
  })
}

export function threeDSHandlerWithMandate(store, payment_method, options = {}, mandateDescription) {
  const pm = store.getters.pm_by_type(payment_method.type);
  if(pm && pm.mandate_config && pm.mandate_config.enabled) {
    return threeDSHandler(store, payment_method, options, { requireMandate: true, description: mandateDescription })
  }
  return threeDSHandler(store, payment_method, options)
}

export function threeDSHandler(store, payment_method, options = {}, mandate) {
  const getters = store.getters;
  return createPaymentIntent(store, payment_method, options)
    .then(payment_intent => {
      let threeDShandler = Chargebee.getInstance().create3DSHandler();
      let options = {}, additionalInfo ={};
      if(payment_intent.gateway == "braintree" && btClientInstance) {
          options["braintree"] = btClientInstance;
      }
      threeDShandler.setPaymentIntent(payment_intent, options);
      let params3ds = {}
      if(payment_method.tmp_token) {
          params3ds['tokenizer'] = () => Promise.resolve(payment_method.tmp_token);
      }
      else if(payment_method.number) {
        params3ds['card'] = {
          firstName:  payment_method.first_name,
          lastName: payment_method.last_name,
          number: payment_method.number.replace(/\s+/g, ''),
          cvv: payment_method.cvv,
          expiryMonth: payment_method.expiry_month,
          expiryYear: payment_method.expiry_year > 100 ? payment_method.expiry_year : (2000 + parseInt(payment_method.expiry_year))
        }
        additionalInfo['plan'] = deepGet(getters.cart_plan, 'details.invoice_name') || deepGet(getters.cart_plan, 'details.name') || deepGet(getters.cart_plan, 'id');
        additionalInfo['shippingAddress'] = getShippingAddress(store);
        additionalInfo['email'] = getters.customer_data.email;
        additionalInfo['billingAddress'] = getCardBillingAddress(payment_method);
        additionalInfo['cardBillingAddress'] = getCardBillingAddress(payment_method);
        additionalInfo['customerBillingAddress'] = getCustomerBillingAddress(store);
        additionalInfo['customer'] = getCustomerInfo(store);
        additionalInfo['locale'] = getters.init_info_locale && getters.init_info_locale.slice(0,2);
      }
      if(payment_intent.gateway == "cybersource" || payment_intent.gateway == "worldpay") {
        additionalInfo['email'] = getters.customer_data.email;
      }
      if(mandate && mandate.requireMandate) {
        additionalInfo['mandate'] = {
          requireMandate: mandate.requireMandate,
          description: mandate.description || deepGet(getters.cart_plan, 'details.invoice_name') || deepGet(getters.cart_plan, 'details.name') || deepGet(getters.cart_plan, 'id'),
        };
      }
      if(payment_intent.gateway == "razorpay") {
        additionalInfo['customer'].firstName = payment_method.first_name;
        additionalInfo['customer'].lastName = payment_method.last_name;
        additionalInfo['customer']. phone = payment_method.phone;
        additionalInfo['customer'].email = payment_method.email;
      }
      if(Object.keys(additionalInfo).length > 0) {
        params3ds['additionalData'] = additionalInfo;
      }
      return threeDShandler.handleCardPayment(params3ds).then((intent) => {
        store.dispatch("set_payment_intent", intent);
        return intent;
      });
  })
}
